/* ==========================================================================
   Pflegewegweiser Produktseite

   - Optionswahl: nur Kombinationen, die es wirklich gibt. Waehlt man eine
     Groesse, deren Verpackungseinheit es nicht gibt, springt die Auswahl auf
     die erste verfuegbare Einheit dieser Groesse.
   - Preis, Stueckpreis, Lagerstatus, Bild und Sticky-Leiste folgen der Wahl.
   - Sticky-CTA: Desktop oben, sobald der echte Button aus dem Bild scrollt.
     Mobile dauerhaft unten.
   - Tab-Leiste und Sticky-Leiste kleben unter dem Header; dessen Hoehe wird
     gemessen, weil sie je Breite und Ankuendigungsbalken anders ist.
   ========================================================================== */

(function () {
  'use strict';

  var MOBIL = 999;

  function zahl(el, attr) {
    var v = parseInt(el.getAttribute(attr), 10);
    return isNaN(v) ? -1 : v;
  }

  /* ------------------------------------------------- Hoehe des Kopfbereichs */

  /* Wie viel ist oben vom Header belegt? Nur wenn er wirklich klebt und
     gerade auch oben steht – sonst waere der Versatz Luft. */
  function kopfHoehe() {
    var header = document.querySelector('[data-pww-header]');
    if (!header) return 0;

    var stil = window.getComputedStyle(header);
    if (stil.position !== 'sticky' && stil.position !== 'fixed') return 0;

    var r = header.getBoundingClientRect();
    if (r.bottom <= 0) return 0;
    return Math.round(r.bottom);
  }

  function stickyVersatz() {
    var hoehe = kopfHoehe();
    document.documentElement.style.setProperty('--pww-sticky-top', hoehe + 'px');
    return hoehe;
  }

  /* ------------------------------------------------ Einmal pro Bild, nicht
                                                      einmal pro Ereignis

     Scroll-Ereignisse kommen haeufiger als der Browser zeichnet – auf manchen
     Geraeten mehrfach zwischen zwei Bildern. Jeder Durchgang hier liest die
     Lage von Elementen (getBoundingClientRect, scrollHeight), und jedes Lesen
     nach einer Aenderung zwingt den Browser, das Layout sofort neu zu rechnen.

     Gemessen auf der Produktseite: 0.9 ms je Scroll-Ereignis, gegenueber
     0.07 ms auf der Kategorieseite. Auf einem schnellen Rechner faellt das
     nicht auf, auf einem aelteren Handy ist es ein spuerbarer Teil der
     16.7 ms, die ein Bild hat.

     proBild sorgt dafuer, dass die Arbeit hoechstens einmal je gezeichnetem
     Bild laeuft. Die Kopfzeile macht das schon lange so (pww-header.js). */
  function proBild(arbeit) {
    var offen = null;
    return function () {
      if (offen) return;
      offen = window.requestAnimationFrame(function () {
        offen = null;
        arbeit();
      });
    };
  }

  /* ------------------------------------------------ Galeriehoehe deckeln

     Die Buehne ist quadratisch und damit so hoch wie ihre Spalte breit ist. Auf
     flachen Bildschirmen stand das Bild deshalb halb unter der Falz. Gemessen
     wird, was ueber der Buehne steht (Kopfzeile, Brotkrume, Innenabstand) und
     was unter ihr folgt (Bildstreifen); der Rest ist der Deckel.

     Bewusst gemessen statt gerechnet: eine Formel mit --pww-sticky-top ging
     daneben, weil dieser Wert je nach Scrollstand zwischen Voll- und
     Resthoehe der Kopfzeile schwankt. Der Abstand vom Seitenanfang tut das
     nicht – deshalb scrollY dazu.

     GAL_MIN verhindert, dass die Buehne auf sehr flachen Fenstern zum Streifen
     wird; dort ragt sie dann wieder etwas heraus, was ehrlicher ist als ein
     unkenntliches Bild. */
  var GAL_MIN = 260;
  var GAL_PUFFER = 16;

  /* Bilder, deren Adresse in data-Attributen wartet, scharf schalten. Gebraucht
     von der Galerie (nur das erste Bild kommt mit src) und von der grossen
     Bildansicht. Zweimal aufrufen schadet nicht: nach dem ersten Mal sind die
     Attribute weg. */
  function bildScharf(bild) {
    if (!bild) return;
    var quelle = bild.getAttribute('data-pww-src');
    if (!quelle) return;
    var satz = bild.getAttribute('data-pww-srcset');
    if (satz) bild.setAttribute('srcset', satz);
    bild.setAttribute('src', quelle);
    bild.removeAttribute('data-pww-src');
    bild.removeAttribute('data-pww-srcset');
  }

  function bilderScharf(bereich) {
    if (!bereich) return;
    Array.prototype.slice.call(bereich.querySelectorAll('img[data-pww-src]')).forEach(bildScharf);
  }

  function galerieDeckel() {
    var buehne = document.querySelector('.pww-gal__stage');
    if (!buehne) return;

    /* Auf Mobile ist die Buehne der Wischstreifen und braucht keinen Deckel. */
    if (window.innerWidth < 1000) {
      document.documentElement.style.removeProperty('--pww-gal-max');
      return;
    }

    var galerie = buehne.closest('.pww-gal');
    var bKasten = buehne.getBoundingClientRect();
    var versatz = window.scrollY || window.pageYOffset || 0;

    /* Abstand der Galerie vom Seitenanfang – gemessen an .pww-pd, nicht an der
       Buehne selbst. Die Galeriespalte laeuft mit (sticky); nach dem Scrollen
       ist ihre Position im Fenster die Klebeposition und nicht mehr der Abstand
       vom Seitenanfang. Mit ihr gerechnet waere der Deckel bei jedem
       Fenstergroessen-Wechsel waehrend des Scrollens zu klein geworden, und die
       Buehne haette sich Stueck fuer Stueck zusammengezogen. .pww-pd klebt
       nicht und liefert denselben Wert wie die Buehne am Seitenanfang. */
    var reihe = buehne.closest('.pww-pd');
    var oben = bKasten.top + versatz;
    if (reihe) {
      var rKasten = reihe.getBoundingClientRect();
      oben = rKasten.top + versatz + (parseFloat(getComputedStyle(reihe).paddingTop) || 0);
    }

    var unten = galerie ? galerie.getBoundingClientRect().bottom - bKasten.bottom : 0;
    var platz = window.innerHeight - oben - unten - GAL_PUFFER;

    document.documentElement.style.setProperty('--pww-gal-max', Math.max(Math.round(platz), GAL_MIN) + 'px');
  }

  /* ------------------------------------------------------------- Produktteil */

  function initProdukt(wurzel) {
    if (wurzel.dataset.pwwInit === 'true') return;
    wurzel.dataset.pwwInit = 'true';

    var datenTag = wurzel.querySelector('[data-pww-variants]');
    var varianten = [];
    if (datenTag) {
      try {
        varianten = JSON.parse(datenTag.textContent) || [];
      } catch (e) {
        varianten = [];
      }
    }

    var packIndex = zahl(wurzel, 'data-pww-pack-index');
    var ctaLabel = wurzel.getAttribute('data-pww-cta-label') || '';
    var ctaSoldout = wurzel.getAttribute('data-pww-cta-soldout') || '';
    var notifyLabel = wurzel.getAttribute('data-pww-cta-notify') || '';
    var meldenLabel = wurzel.getAttribute('data-pww-cta-melden') || '';
    var stockIn = wurzel.getAttribute('data-pww-stock-in') || '';
    var stockOut = wurzel.getAttribute('data-pww-stock-out') || '';
    /* Derselbe Text als Kurzhinweis am durchgestrichenen Knopf – so muss er
       nicht doppelt gepflegt werden. */
    var ausverkauftHinweis = stockOut;
    var unitPattern = wurzel.getAttribute('data-pww-unit-pattern') || '';
    var savePattern = wurzel.getAttribute('data-pww-save-pattern') || '';
    var saveMin = parseInt(wurzel.getAttribute('data-pww-save-min'), 10);
    if (isNaN(saveMin)) saveMin = 0;

    var form = document.getElementById(wurzel.getAttribute('data-pww-form'));
    var idFeld = form ? form.querySelector('input[name="id"]') : null;

    var knoepfe = Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-choose]'));
    var gewaehlt = [];

    /* Startzustand aus dem gerenderten Markup lesen, nicht raten. */
    knoepfe.forEach(function (b) {
      if (b.classList.contains('is-active')) {
        gewaehlt[zahl(b, 'data-pww-choose')] = b.getAttribute('data-pww-value');
      }
    });

    function varianteFuer(werte) {
      for (var i = 0; i < varianten.length; i++) {
        var passt = true;
        for (var j = 0; j < werte.length; j++) {
          if (werte[j] !== undefined && varianten[i].o[j] !== werte[j]) {
            passt = false;
            break;
          }
        }
        if (passt) return varianten[i];
      }
      return null;
    }

    /* Gibt es zu diesen Teilwerten ueberhaupt eine Variante? Damit werden
       Optionswerte ausgegraut, die in Kombination nicht existieren. */
    function existiert(werte) {
      return varianteFuer(werte) !== null;
    }

    /* Ist zu diesen Teilwerten mindestens eine Variante lieferbar?

       existiert() reicht dafuer nicht: eine ausverkaufte Groesse existiert
       weiterhin, sie war darum nicht als ausverkauft zu erkennen. Gesucht wird
       die erste passende *lieferbare* Variante, nicht die erste passende – bei
       mehreren Verpackungen zur selben Groesse kann eine leer und eine an
       Lager sein. */
    function lieferbar(werte) {
      for (var i = 0; i < varianten.length; i++) {
        if (!varianten[i].avail) continue;
        var passt = true;
        for (var j = 0; j < werte.length; j++) {
          if (werte[j] !== undefined && varianten[i].o[j] !== werte[j]) {
            passt = false;
            break;
          }
        }
        if (passt) return true;
      }
      return false;
    }

    function textSetzen(sel, text) {
      Array.prototype.slice.call(wurzel.querySelectorAll(sel)).forEach(function (el) {
        el.textContent = text;
      });
    }

    function zeigen(sel, sichtbar) {
      Array.prototype.slice.call(wurzel.querySelectorAll(sel)).forEach(function (el) {
        el.hidden = !sichtbar;
      });
    }

    /* --------------------------------------------------------------- Galerie */

    var galerie = wurzel.querySelector('[data-pww-gallery]');
    var buehne = galerie ? galerie.querySelector('.pww-gal__stage') : null;

    function markiere(attr, index) {
      if (!galerie) return;
      Array.prototype.slice.call(galerie.querySelectorAll('[' + attr + ']')).forEach(function (el) {
        el.classList.toggle('is-active', String(index) === el.getAttribute(attr));
      });
    }

    /* Der Schalter kommt aus dem CSS (--pww-strip in der Mobile-Abfrage).
       overflow-x taugt nicht: auf Desktop steht dort hidden, was ebenfalls
       nicht "visible" ist – dadurch wurde auch am Desktop gescrollt statt
       umgeschaltet und der Klick aufs Vorschaubild blieb ohne Wirkung. */
    function istStreifen() {
      if (!buehne) return false;
      return window.getComputedStyle(buehne).getPropertyValue('--pww-strip').trim() === '1';
    }

    function bildZeigen(index, scrollen) {
      if (!galerie || index < 0) return;

      /* Das angesteuerte Bild und seinen Nachbarn scharf schalten – im Markup
         steht nur beim ersten eine Adresse. Der Nachbar vorab, damit das
         Weiterklicken nicht auf den Download wartet. */
      var folien = buehne ? buehne.querySelectorAll('[data-pww-slide]') : [];
      [index, index + 1].forEach(function (i) {
        if (folien[i]) bildScharf(folien[i].querySelector('img[data-pww-src]'));
      });

      markiere('data-pww-thumb', index);
      markiere('data-pww-dot', index);

      if (istStreifen()) {
        /* Auf schmalen Breiten liegen die Bilder als Streifen nebeneinander;
           dort wird gescrollt statt umgeschaltet.

           offsetLeft der Folie ist bereits relativ zur Buehne, die ihr
           offsetParent ist – nichts abziehen. Und die Zuweisung statt
           scrollTo({behavior:'smooth'}): das Sanfte macht scroll-behavior im
           CSS, eine reine Zuweisung greift auch dort, wo die Animation nicht
           laeuft. */
        var folie = buehne.querySelector('[data-pww-slide="' + index + '"]');
        if (folie && scrollen) {
          buehne.scrollLeft = folie.offsetLeft;
        }
      } else {
        markiere('data-pww-slide', index);
      }
    }

    /* Beim Wischen den aktiven Punkt nachziehen. */
    function punkteNachScroll() {
      if (!buehne || !istStreifen()) return;
      var folien = Array.prototype.slice.call(buehne.querySelectorAll('[data-pww-slide]'));
      var mitte = buehne.scrollLeft + buehne.clientWidth / 2;
      var naechste = 0;
      var kleinster = Infinity;
      folien.forEach(function (f, i) {
        var fm = f.offsetLeft - buehne.offsetLeft + f.offsetWidth / 2;
        var abstand = Math.abs(fm - mitte);
        if (abstand < kleinster) {
          kleinster = abstand;
          naechste = i;
        }
      });

      /* Die angepeilte Folie samt Nachbarn scharf schalten. Das Wischen war
         bisher kein Nachlade-Anlass – wer vor dem Hintergrund-Nachladen
         wischte, sah eine leere Folie. */
      [naechste - 1, naechste, naechste + 1].forEach(function (i) {
        if (folien[i]) bildScharf(folien[i].querySelector('img[data-pww-src]'));
      });

      markiere('data-pww-dot', naechste);
    }

    if (galerie) {
      galerie.addEventListener('click', function (ev) {
        var ziel = ev.target.closest('[data-pww-thumb], [data-pww-dot]');
        if (!ziel) return;
        var i = ziel.hasAttribute('data-pww-thumb')
          ? zahl(ziel, 'data-pww-thumb')
          : zahl(ziel, 'data-pww-dot');
        bildZeigen(i, true);
      });
    }

    /* -------------------------------------------- Vorschaureihe blaettern */

    /* Acht Bilder, fuenf Plaetze: der Rest liegt rechts daneben. Geblaettert
       wird um eine Sichtbreite, die Pfeile verschwinden am jeweiligen Ende. */
    var streifen = wurzel.querySelector('[data-pww-thumbstrip]');
    if (streifen) {
      var sicht = streifen.querySelector('[data-pww-thumbview]');
      var zurueckBtn = streifen.querySelector('[data-pww-thumb-prev]');
      var weiterBtn = streifen.querySelector('[data-pww-thumb-next]');

      var pfeilePruefen = function () {
        if (!sicht) return;
        var ueberhang = sicht.scrollWidth - sicht.clientWidth;
        if (zurueckBtn) zurueckBtn.hidden = ueberhang <= 4 || sicht.scrollLeft <= 4;
        if (weiterBtn) weiterBtn.hidden = ueberhang <= 4 || sicht.scrollLeft >= ueberhang - 4;
      };

      var blaettern = function (richtung) {
        if (!sicht) return;
        var vorher = sicht.scrollLeft;
        var ziel = vorher + richtung * Math.round(sicht.clientWidth * 0.9);
        try {
          sicht.scrollTo({ left: ziel, behavior: 'smooth' });
        } catch (e) {
          sicht.scrollLeft = ziel;
        }
        /* Sicherheitsnetz: bleibt die sanfte Bewegung aus, wird hart gesetzt.
           Sonst bliebe der Pfeil ohne Wirkung. */
        setTimeout(function () {
          if (sicht.scrollLeft === vorher) sicht.scrollLeft = ziel;
          pfeilePruefen();
        }, 350);
      };

      if (zurueckBtn) {
        zurueckBtn.addEventListener('click', function () {
          blaettern(-1);
        });
      }
      if (weiterBtn) {
        weiterBtn.addEventListener('click', function () {
          blaettern(1);
        });
      }
      if (sicht) {
        sicht.addEventListener('scroll', pfeilePruefen, { passive: true });
      }
      window.addEventListener('resize', pfeilePruefen);

      /* Bilder liegen beim ersten Durchlauf oft noch ohne Groesse vor, dann
         waere scrollWidth gleich clientWidth und beide Pfeile blieben aus. */
      pfeilePruefen();
      window.addEventListener('load', pfeilePruefen);
      setTimeout(pfeilePruefen, 400);
    }

    if (buehne) {
      buehne.addEventListener('scroll', punkteNachScroll, { passive: true });

      /* Das zweite Bild gleich mitladen: der allererste Klick oder Wisch
         soll nie auf den Download warten. Ab dann laedt bildZeigen jeweils
         den Nachbarn vor. */
      var zweite = buehne.querySelectorAll('[data-pww-slide]')[1];
      if (zweite) bildScharf(zweite.querySelector('img[data-pww-src]'));
    }

    /* ------------------------------------------------------- Zustand setzen */

    function aktualisieren(scrollBild) {
      var v = varianteFuer(gewaehlt);

      /* Führt die Wahl ins Leere, auf die erste passende Variante ausweichen:
         bei TENA Pants Discreet hat M eine 12er- und L eine 10er-Packung. */
      if (!v && packIndex >= 0) {
        var teil = gewaehlt.slice();
        teil[packIndex] = undefined;
        v = varianteFuer(teil);
        if (v) gewaehlt = v.o.slice();
      }
      if (!v) return;

      /* Knopfzustaende */
      knoepfe.forEach(function (b) {
        var i = zahl(b, 'data-pww-choose');
        var wert = b.getAttribute('data-pww-value');
        var probe = gewaehlt.slice();
        probe[i] = wert;

        /* Fuer die Pruefung nur die Optionen vor dieser beruecksichtigen –
           sonst wirken spaetere Wahlen rueckwaerts einschraenkend. */
        for (var k = i + 1; k < probe.length; k++) probe[k] = undefined;

        /* Zwei verschiedene Zustaende, die nicht verwechselt werden duerfen:

             existiert nicht  – die Kombination gibt es gar nicht, der Knopf
                                bleibt gesperrt.
             ausverkauft      – die Groesse gibt es, ist aber leer. Der Knopf
                                bleibt anklickbar, damit man sie ueberhaupt
                                waehlen kann und Lagerzeile und Kaufbutton den
                                Zustand zeigen. Durchgestrichen ist er in
                                beiden Faellen.

         Das Benachrichtigungs-Formular kommt von Klaviyo und richtet sich nach
         der Variante in der Adresse, nicht nach dieser Auswahl – es folgt einem
         Wechsel hier also nicht. */
        var moeglich = existiert(probe);
        var amLager = moeglich && lieferbar(probe);
        b.classList.toggle('is-active', gewaehlt[i] === wert);
        b.classList.toggle('is-soldout', !amLager);
        b.disabled = !moeglich;
        if (!amLager && moeglich) {
          b.setAttribute('title', ausverkauftHinweis);
        } else {
          b.removeAttribute('title');
        }
      });

      /* Die Klappliste traegt denselben Zustand wie die Pillen. */
      listenAbgleichen();

      /* Stueckpreis je Verpackungskarte: der Wert haengt an der gewaehlten
         Groesse, darum wird er hier neu geschrieben statt in Liquid. */
      if (packIndex >= 0) {
        Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-pack-meta]')).forEach(function (el) {
          var wert = el.getAttribute('data-pww-pack-meta');
          var probe = gewaehlt.slice();
          probe[packIndex] = wert;
          var pv = varianteFuer(probe);
          var karte = el.closest('.pww-pack__card');

          /* Verpackungen, die es zur gewaehlten Groesse nicht gibt, ganz
             ausblenden. Eine graue Karte ohne Stueckpreis sieht nach Fehler
             aus – bei TENA Pants Discreet gibt es M nur als 12er, L nur
             als 10er. */
          if (karte) karte.hidden = !pv;
          if (!pv) {
            el.textContent = '';
            return;
          }

          /* Verpackung vorhanden, aber leer: dann statt des Stueckpreises der
             Grund. Nur blass zu sein sagt zu wenig. */
          if (!pv.avail) {
            if (karte) karte.classList.add('is-soldout');
            el.textContent = stockOut;
            return;
          }
          if (karte) karte.classList.remove('is-soldout');

          var teile = [];
          if (pv.pp) teile.push(unitPattern.replace('[preis]', pv.pp));
          /* Unter der Untergrenze bleibt der Hinweis weg – «1% günstiger»
             ueberzeugt niemanden. */
          if (pv.save >= saveMin && pv.save > 0 && savePattern) {
            teile.push(savePattern.replace('[prozent]', pv.save));
          }
          el.textContent = teile.join(' · ');
        });
      }

      /* Beschriftung «Grösse: M» */
      Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-opt-value]')).forEach(function (el) {
        var i = zahl(el, 'data-pww-opt-value');
        el.textContent = v.o[i] || '';
      });

      /* Preis */
      textSetzen('[data-pww-price]', v.price);
      textSetzen('[data-pww-sticky-price]', v.price);
      if (v.compare) {
        textSetzen('[data-pww-compare]', v.compare);
        zeigen('[data-pww-compare]', true);
      } else {
        zeigen('[data-pww-compare]', false);
      }

      /* Aktionsfarbe mitziehen: bei mehreren Verpackungen kann eine reduziert
         sein und die andere nicht. */
      Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-price-box]')).forEach(function (el) {
        el.classList.toggle('is-sale', !!v.compare);
      });

      if (v.off > 0) {
        textSetzen('[data-pww-off]', '–' + v.off + '%');
        zeigen('[data-pww-off]', true);
      } else {
        zeigen('[data-pww-off]', false);
      }

      /* Lager und Button */
      var stock = wurzel.querySelector('[data-pww-stock]');
      if (stock) stock.classList.toggle('is-out', !v.avail);
      textSetzen('[data-pww-stock-text]', v.avail ? stockIn : stockOut);
      textSetzen('[data-pww-cta-text]', v.avail ? ctaLabel : ctaSoldout);
      Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-submit]')).forEach(function (b) {
        b.disabled = !v.avail;
      });

      /* Kaufknopf ohne Bestand: gleicher Wortlaut und gleiches Grau wie der
         Knopf, den Klaviyo darueberlegt, sobald deren Skript geladen hat.
         Vorher stand hier bis dahin "Nicht verfuegbar" und sprang dann
         sichtbar um. Gesperrt bleibt er trotzdem – ohne Klaviyo gibt es
         nichts zu melden. */
      var kaufKnopf = wurzel.querySelector('.pww-atc [data-pww-submit]');
      if (kaufKnopf) {
        kaufKnopf.classList.toggle('is-melden', !v.avail && !!meldenLabel);
        var kaufText = kaufKnopf.querySelector('[data-pww-cta-text]');
        if (kaufText && !v.avail && meldenLabel) kaufText.textContent = meldenLabel;
      }

      /* Sticky-Zeile. "Default Title" ist Shopifys Name der einzigen Variante –
         der gehoert nicht in den Balken, dort steht dann der Ersatztext. */
      var metaText = v.title;
      if (!metaText || metaText === 'Default Title') {
        metaText = wurzel.getAttribute('data-pww-sticky-fallback') || '';
      }
      textSetzen('[data-pww-sticky-meta]', metaText);

      /* Streichpreis in der Sprungleiste – dieselbe Quelle wie in der Kaufbox.
         is-sale faerbt dort den gueltigen Preis pink, wie in der Kaufbox. */
      if (v.compare) {
        textSetzen('[data-pww-sticky-compare]', v.compare);
        zeigen('[data-pww-sticky-compare]', true);
      } else {
        zeigen('[data-pww-sticky-compare]', false);
      }
      Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-sticky]')).forEach(function (leiste) {
        leiste.classList.toggle('is-sale', !!v.compare);
      });

      /* Knopf in der Sprungleiste ohne Bestand: Klaviyos Benachrichtigungs-
         formular steht nur in der Kaufbox, es laesst sich nicht zweimal
         einbinden. Der Knopf wird darum ein Sprung dorthin – gesperrt und
         "Nicht verfuegbar" hilft niemandem. Die Zeile muss nach der Schleife
         oben stehen, die alle [data-pww-submit] sperrt. */
      Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-sticky] [data-pww-submit]')).forEach(function (b) {
        var beschriftung = b.querySelector('[data-pww-cta-text]');
        var melden = !v.avail && notifyLabel;
        b.classList.toggle('is-notify', !!melden);
        b.disabled = melden ? false : !v.avail;
        b.setAttribute('type', melden ? 'button' : 'submit');
        if (beschriftung && melden) beschriftung.textContent = notifyLabel;
      });

      /* Formular */
      if (idFeld) idFeld.value = v.id;

      /* Bild der Variante */
      if (v.media >= 0 && scrollBild) bildZeigen(v.media, true);

      /* URL mitziehen, damit Teilen und Neuladen die Wahl behalten */
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    knoepfe.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        gewaehlt[zahl(b, 'data-pww-choose')] = b.getAttribute('data-pww-value');
        aktualisieren(true);
      });
    });

    /* ------------------------------------ Klappliste statt Pillenreihe

       Auf dem Handy passen lange Wertelisten nicht in eine Zeile. Zwei, drei
       Reihen Pillen schieben Preis und Kaufknopf weit nach unten – bei sechs
       Geschmacksrichtungen war die halbe Kaufbox nur noch Auswahl. Bricht eine
       Gruppe um, wird sie darum zur Klappliste.

       Gemessen statt geraten: verglichen wird die Oberkante der ersten mit der
       der letzten Pille. Liegen sie auf gleicher Hoehe, passt alles in eine
       Zeile und die Pillen bleiben – bei "S M L XL" sind sie die schnellere
       Wahl.

       Die Pillen bleiben im Dokument und behalten ihre Zustaende; die Liste
       schaltet nur durch. So gibt es weiter genau eine Wahrheit, und die
       bestehende Logik fuer ausverkauft und nicht-kombinierbar gilt unveraendert.

       Die Verpackungseinheit ist bewusst ausgenommen: sie steht als Kartenpaar
       mit Stueckpreis da, das ist die Preisentscheidung und keine Nebenwahl. */

    var listen = [];

    function listenAbbauen() {
      listen.forEach(function (l) {
        if (l.huelle.parentNode) l.huelle.parentNode.removeChild(l.huelle);
        l.gruppe.classList.remove('is-liste');
      });
      listen = [];
    }

    function listenAufbauen() {
      if (window.innerWidth > MOBIL) return;

      Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-opt]')).forEach(function (gruppe) {
        var feld = gruppe.querySelector('.pww-opt__values');
        if (!feld) return;

        var pillen = Array.prototype.slice.call(feld.querySelectorAll('.pww-swatch'));
        if (pillen.length < 2) return;

        /* Bricht die Reihe um? */
        var erste = pillen[0].offsetTop;
        var bricht = pillen.some(function (p) { return p.offsetTop > erste + 2; });
        if (!bricht) return;

        /* Eigene Liste statt <select>: die aufgeklappte Systemliste laesst sich
           nicht gestalten – blaue Markierung, fremde Schrift, harte Ecken. Ein
           Knopf mit eigener Liste traegt dieselbe Sprache wie die Aufklapper
           der Filterleiste. */
        var beschriftung = gruppe.querySelector('.pww-opt__label');
        var name = beschriftung ? beschriftung.textContent.split(':')[0].trim() : 'Auswahl';

        var huelle = document.createElement('div');
        huelle.className = 'pww-opt__wahl';

        var knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = 'pww-opt__knopf';
        knopf.setAttribute('aria-haspopup', 'listbox');
        knopf.setAttribute('aria-expanded', 'false');
        knopf.setAttribute('aria-label', name);
        knopf.innerHTML = '<span class="pww-opt__knopftext"></span>' +
          '<span class="pww-opt__knopfchev" aria-hidden="true">' +
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>' +
          '</span>';

        var liste = document.createElement('div');
        liste.className = 'pww-opt__liste';
        liste.setAttribute('role', 'listbox');
        liste.hidden = true;

        function zuKlappen() {
          liste.hidden = true;
          knopf.setAttribute('aria-expanded', 'false');
          huelle.classList.remove('is-offen');
        }

        function aufKlappen() {
          /* Immer nur eine Liste offen. */
          listen.forEach(function (l) { if (l.zu) l.zu(); });
          liste.hidden = false;
          knopf.setAttribute('aria-expanded', 'true');
          huelle.classList.add('is-offen');
        }

        var zeilen = pillen.map(function (p) {
          var z = document.createElement('button');
          z.type = 'button';
          z.className = 'pww-opt__zeile';
          z.setAttribute('role', 'option');
          z.innerHTML = '<span class="pww-opt__zeilentext"></span>' +
            '<span class="pww-opt__zeilenhaken" aria-hidden="true">' +
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
            '</span>';
          z.addEventListener('click', function () {
            if (p.disabled) return;
            zuKlappen();
            p.click();
          });
          liste.appendChild(z);
          return z;
        });

        knopf.addEventListener('click', function (ev) {
          ev.stopPropagation();
          if (liste.hidden) aufKlappen();
          else zuKlappen();
        });

        /* Klick daneben schliesst – wie bei den Filtern der Kategorieseite. */
        document.addEventListener('click', function (ev) {
          if (!liste.hidden && !huelle.contains(ev.target)) zuKlappen();
        });

        huelle.addEventListener('keydown', function (ev) {
          if (ev.key === 'Escape') {
            zuKlappen();
            knopf.focus();
          }
        });

        huelle.appendChild(knopf);
        huelle.appendChild(liste);
        feld.parentNode.insertBefore(huelle, feld.nextSibling);
        gruppe.classList.add('is-liste');
        listen.push({ gruppe: gruppe, huelle: huelle, knopf: knopf, zeilen: zeilen, pillen: pillen, zu: zuKlappen });
      });

      listenAbgleichen();
    }

    function listenAbgleichen() {
      listen.forEach(function (l) {
        l.pillen.forEach(function (p, i) {
          var z = l.zeilen[i];
          if (!z) return;
          var wert = p.getAttribute('data-pww-value');
          var leer = p.classList.contains('is-soldout') && !p.disabled;
          var aktiv = p.classList.contains('is-active');

          z.querySelector('.pww-opt__zeilentext').textContent = wert;
          z.classList.toggle('is-leer', leer);
          z.classList.toggle('is-aktiv', aktiv);
          z.disabled = p.disabled;
          z.setAttribute('aria-selected', aktiv ? 'true' : 'false');

          if (aktiv) l.knopf.querySelector('.pww-opt__knopftext').textContent = wert;
        });
      });
    }

    /* Immer erst abbauen, dann neu messen: die Pillen muessen sichtbar sein,
       sonst liegen alle auf derselben Hoehe und nichts sieht nach Umbruch aus. */
    function listenNeu() {
      listenAbbauen();
      listenAufbauen();
    }

    /* Mehrfach nachfassen statt einmal raten.

       Beim ersten Zeichnen steht die Breite der Kaufspalte noch nicht fest –
       Schriften und Bilder fehlen dann noch, und die Pillen lagen alle auf
       einer Zeile. Gemessen wurde also "passt", obwohl sie spaeter auf drei
       Zeilen umbrachen. Darum: einmal sofort, einmal wenn die Seite steht,
       und ein spaeter Nachschlag fuer langsame Verbindungen. Der Aufbau ist
       wiederholbar, mehrfaches Laufen schadet nicht. */
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(listenNeu);
    } else {
      window.setTimeout(listenNeu, 60);
    }
    window.addEventListener('load', listenNeu);
    window.setTimeout(listenNeu, 700);

    /* Nach einem Groessenwechsel neu entscheiden – deckt beide Richtungen ab,
       auch den Weg zurueck zum Desktop. */
    var listenTakt = null;
    window.addEventListener('resize', function () {
      if (listenTakt) window.clearTimeout(listenTakt);
      listenTakt = window.setTimeout(listenNeu, 200);
    });

    /* ----------------------------------------------------------------- Menge */

    var mengeFeld = wurzel.querySelector('[data-pww-qty-input]');
    Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-qty]')).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!mengeFeld) return;
        var neu = (parseInt(mengeFeld.value, 10) || 1) + zahl(b, 'data-pww-qty');
        mengeFeld.value = Math.max(1, neu);
      });
    });

    /* Getippte Eingabe genauso klemmen wie die Knoepfe.

       min="1" im Markup faengt die 0 ab – der Browser laesst das Formular dann
       nicht abschicken. Ein leeres Feld gilt ihm dagegen als gueltig (ohne
       required greift min nicht), und das entsteht leicht: Feld markieren,
       Buchstaben tippen, schon ist es leer. Abgeschickt wuerde dann eine
       Menge, die gar nicht dasteht. */
    if (mengeFeld) {
      mengeFeld.addEventListener('change', function () {
        var wert = parseInt(mengeFeld.value, 10);
        if (isNaN(wert) || wert < 1) mengeFeld.value = 1;
      });
    }

    /* ------------------------------------------------------------- Sticky-CTA */

    var stickyTop = wurzel.querySelector('[data-pww-sticky="top"]');
    var stickyBottom = wurzel.querySelector('[data-pww-sticky="bottom"]');
    var willTop = wurzel.getAttribute('data-pww-sticky-desktop') === 'true';
    var willBottom = wurzel.getAttribute('data-pww-sticky-mobile') === 'true';
    var echterCta = wurzel.querySelector('.pww-atc [data-pww-submit]');

    /* Der Detailbereich als Ausloeser fuer die Kaufleiste auf dem Handy. Er ist
       eine eigene Section, liegt also ausserhalb dieser Wurzel – darum ueber
       das Dokument gesucht. Fehlt er in einer Vorlage, greift weiter unten der
       Ersatz ueber den echten Kaufknopf. */
    var detailAnker = document.getElementById('pww-details');

    function stickyPruefen() {
      var mobil = window.innerWidth <= MOBIL;
      var anTop = false;

      if (stickyTop) {
        if (willTop && !mobil && echterCta) {
          /* Sichtbar, sobald der echte Button oben aus dem Bild ist. Die
             Leiste haengt am Bildrand (top: 0), darum ist die Grenze 0. */
          anTop = echterCta.getBoundingClientRect().bottom < 0;
        }
        stickyTop.hidden = !anTop;
        stickyTop.classList.toggle('is-on', anTop);
      }

      if (stickyBottom) {
        var anBottom = willBottom && mobil;

        /* Nicht schon beim Aufschlagen: die Leiste deckt auf kleinen Geraeten
           ein Fuenftel des Bildes ab, waehrend der echte Kaufknopf noch zu
           sehen ist – zwei Kaufknoepfe gleichzeitig. Sie kommt erst, wenn der
           Detailbereich ins Bild ruckt, man also am Lesen ist und den Knopf
           oben hinter sich gelassen hat. */
        if (anBottom) {
          if (detailAnker) {
            anBottom = detailAnker.getBoundingClientRect().top < window.innerHeight;
          } else if (echterCta) {
            anBottom = echterCta.getBoundingClientRect().bottom < 0;
          }
        }
        stickyBottom.hidden = !anBottom;
        stickyBottom.classList.toggle('is-on', anBottom);
      }

      /* Die Tab-Leiste sitzt unter dem, was oben gerade klebt: unter dem
         Sticky-CTA wenn der da ist, sonst unter dem Header. */
      var tabsOben = 0;
      if (anTop && stickyTop) {
        tabsOben = Math.round(stickyTop.getBoundingClientRect().height);
      } else {
        tabsOben = kopfHoehe();
      }
      document.documentElement.style.setProperty('--pww-tabs-top', tabsOben + 'px');
    }

    /* Beim Scrollen gebuendelt, beim Groessenwechsel sofort: ein Resize kommt
       selten und soll nicht ein Bild lang nachhinken. */
    window.addEventListener('scroll', proBild(stickyPruefen), { passive: true });
    window.addEventListener('resize', stickyPruefen);

    /* Sprung zum Benachrichtigungsformular. Klaviyos Knopf hat keine eigene
       Kennung, nur einen festen Klassenanfang – siehe pww-product.css. Erst
       hinscrollen, dann klicken: sonst oeffnet sich das Formular ausserhalb des
       Sichtfelds. Ohne Klaviyo bleibt es beim Sprung zur Kaufbox. */
    wurzel.addEventListener('click', function (ev) {
      var knopf = ev.target.closest ? ev.target.closest('[data-pww-sticky] [data-pww-submit]') : null;
      if (!knopf || !knopf.classList.contains('is-notify')) return;
      ev.preventDefault();

      var kasten = wurzel.querySelector('.pww-atc');
      var melder = kasten && kasten.querySelector('button[class*="kl-private-reset-css"]');
      var ziel = melder || kasten;
      if (ziel) ziel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (melder) setTimeout(function () { melder.click(); }, 400);
    });

    aktualisieren(false);
    stickyPruefen();
  }

  /* ------------------------------------------------------------- Akkordeons */

  function akkordeonOeffnen(item) {
    if (!item || !item.classList.contains('pww-acc__item')) return;
    item.classList.add('is-open');
    var btn = item.querySelector('[data-pww-acc-btn]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function initAkkordeon(wurzel) {
    if (wurzel.dataset.pwwInit === 'true') return;
    wurzel.dataset.pwwInit = 'true';

    Array.prototype.slice.call(wurzel.querySelectorAll('[data-pww-acc-btn]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pww-acc__item');
        if (!item) return;
        var offen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', offen ? 'true' : 'false');
      });
    });
  }

  /* Sprung auf einen Aufklapper – etwa "Grössentabelle ansehen" aus der
     Kaufbox – muss ihn auch aufklappen, sonst landet man auf einem
     geschlossenen Kasten und sieht nichts. */
  function initAnkerAufklappen() {
    if (document.documentElement.dataset.pwwAnker === 'true') return;
    document.documentElement.dataset.pwwAnker = 'true';

    function ausHash() {
      if (!window.location.hash || window.location.hash.length < 2) return;
      var ziel = document.querySelector(window.location.hash);
      if (ziel) akkordeonOeffnen(ziel.closest('.pww-acc__item') || ziel);
    }

    document.addEventListener('click', function (ev) {
      var link = ev.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href');
      if (id.length < 2) return;
      var ziel = document.querySelector(id);
      if (!ziel) return;
      var item = ziel.closest('.pww-acc__item') || (ziel.classList.contains('pww-acc__item') ? ziel : null);
      if (item) akkordeonOeffnen(item);
    });

    window.addEventListener('hashchange', ausHash);
    ausHash();
  }

  /* --------------------------------------------------------------- Tableiste */

  function initTabs(leiste) {
    if (leiste.dataset.pwwInit === 'true') return;
    leiste.dataset.pwwInit = 'true';

    var links = Array.prototype.slice.call(leiste.querySelectorAll('[data-pww-tab]'));
    var ziele = [];

    /* Abschnitte koennen fehlen: die Fragen erscheinen nur, wenn das Produkt
       FAQ-Metafelder hat. Ein Tab ohne Ziel wird ausgeblendet statt ins Leere
       zu springen.

       Das Element allein genuegt als Beweis nicht: die Empfehlungsabschnitte
       geben ihre Huelle samt Anker immer aus, den Inhalt nur, wenn Shopify
       Empfehlungen liefert. Beim Rollator Actimo Home stand "Passt dazu"
       darum in der Leiste, ohne dass es den Abschnitt gab. Darum zaehlt die
       gerenderte Hoehe. */
    function zieleSammeln() {
      ziele = [];
      links.forEach(function (l) {
        var el = document.querySelector(l.getAttribute('href'));
        var da = !!el && el.getBoundingClientRect().height > 8;
        if (da) ziele.push({ link: l, el: el });
        l.hidden = !da;
      });
      leiste.hidden = ziele.length === 0;
    }

    zieleSammeln();

    /* Empfehlungen kommen nachgeladen. Ohne die zweite Runde bliebe der Tab
       auch dann aus, wenn der Abschnitt am Ende doch Inhalt hat. */
    document.addEventListener('pww:inhalt', function () {
      zieleSammeln();
      markieren();
    });
    window.addEventListener('load', function () {
      zieleSammeln();
      markieren();
    });

    if (!ziele.length) return;

    function tabsVersatz() {
      var v = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--pww-tabs-top'), 10);
      return isNaN(v) ? 0 : v;
    }

    /* Sobald die Leiste oben ankommt, wird sie aus dem Fluss genommen. Damit
       die Seite dabei nicht springt, haelt die Huelle die Hoehe offen. */
    var huelle = leiste.parentElement;

    function kleben() {
      var hoehe = Math.round(leiste.getBoundingClientRect().height);
      var fest = leiste.classList.contains('is-fixed');
      var grenze = huelle.getBoundingClientRect().top;

      if (!fest && grenze <= tabsVersatz()) {
        huelle.style.height = hoehe + 'px';
        leiste.classList.add('is-fixed');
      } else if (fest && grenze > tabsVersatz()) {
        leiste.classList.remove('is-fixed');
        huelle.style.removeProperty('height');
      }
    }

    function grenzeJetzt() {
      return tabsVersatz() + leiste.getBoundingClientRect().height + 8;
    }

    function amEnde() {
      var hoehe = document.documentElement.scrollHeight;
      return window.innerHeight + window.pageYOffset >= hoehe - 2;
    }

    function markieren() {
      /* Zwei Pixel Toleranz: die Ankunft nach einem Sprung liegt gerundet
         gerne einen Pixel unter der Grenze, dann waere der Abschnitt formal
         noch nicht erreicht und der Tab davor blieb markiert. */
      var grenze = grenzeJetzt() + 2;
      var aktiv = ziele[0];
      ziele.forEach(function (z) {
        if (z.el.getBoundingClientRect().top <= grenze) aktiv = z;
      });

      /* Der letzte Abschnitt kommt nie ganz nach oben – darunter steht nur
         noch der Footer, die Seite ist vorher zu Ende gescrollt. Ohne diese
         Ausnahme bliebe "Fragen" unerreichbar und der Tab davor markiert. */
      if (amEnde()) aktiv = ziele[ziele.length - 1];

      ziele.forEach(function (z) {
        z.link.classList.toggle('is-active', z === aktiv);
      });
    }

    /* Springen und nachkorrigieren.

       Der Versatz aendert sich durch das Scrollen selbst: solange der Header
       oben steht, sind es 163px, sobald der Sticky-CTA erscheint nur noch 72.
       Ein einmalig berechnetes Ziel liegt darum bis zu 90px zu hoch und der
       Abschnitt gilt als nicht erreicht. Deshalb wird nach dem Sprung
       gemessen und die Differenz nachgeschoben, bis es passt. */
    var nachlauf = null;

    function zuAbschnitt(el) {
      var abstand = function () {
        return el.getBoundingClientRect().top - grenzeJetzt();
      };

      window.scrollTo({ top: window.pageYOffset + abstand(), behavior: 'smooth' });

      if (nachlauf) clearInterval(nachlauf);
      var versuche = 0;
      nachlauf = setInterval(function () {
        versuche++;
        var diff = abstand();
        if (Math.abs(diff) <= 2 || versuche > 15) {
          clearInterval(nachlauf);
          nachlauf = null;
          markieren();
          return;
        }
        window.scrollBy(0, diff);
      }, 90);
    }

    /* Ankersprung um Header und Leiste versetzen, sonst verschwindet die
       Ueberschrift hinter beiden. */
    links.forEach(function (l) {
      l.addEventListener('click', function (ev) {
        var ziel = document.querySelector(l.getAttribute('href'));
        if (!ziel) return;
        ev.preventDefault();
        zuAbschnitt(ziel);
      });
    });

    function beimScrollen() {
      kleben();
      markieren();
    }

    window.addEventListener('scroll', proBild(beimScrollen), { passive: true });
    window.addEventListener('resize', beimScrollen);
    beimScrollen();
  }

  /* ------------------------------------------------- Aehnliche Produkte */

  /* Shopify liefert Empfehlungen nur ueber /recommendations/products. Hier
     wird dieselbe Section nachgeladen und der Inhalt uebernommen. */
  /* Zwei Empfehlungsabschnitte auf einer Seite: "Verwandte Produkte" zeigt die
     von Hand gepflegten Ergaenzungen, "Das kauften andere Kunden" die
     algorithmischen. Beide Quellen sind sich oft einig – gemessen drei von vier
     gleichen Produkten. Zweimal dieselbe Karte untereinander sieht nach Fehler
     aus, also behaelt sie der obere Abschnitt und der untere laesst sie weg.

     Laeuft nach jedem Nachladen, weil die Abschnitte unabhaengig voneinander
     fertig werden – wer zuerst kommt, ist nicht festgelegt. Die Reihenfolge im
     Dokument entscheidet, nicht die Ladereihenfolge. */
  function recosEntdoppeln() {
    var gesehen = {};

    function handleVon(karte) {
      var link = karte.querySelector('a[href*="/products/"]');
      if (!link) return '';
      return link.getAttribute('href').split('/products/')[1].split('?')[0];
    }

    /* Nichts wird entfernt, nur versteckt. Geholt werden vier Karten mehr als
       gezeigt; diese Reserve muss im Dokument bleiben. Sonst gilt: der untere
       Abschnitt laedt zuerst, schneidet seine Reserve weg, danach kommt der
       obere und streicht ihm die verbliebenen vier als Doppel – und er faellt
       ganz weg. Weil hier nur Merkmale gesetzt werden, darf der Durchgang
       beliebig oft laufen und rechnet jedesmal aus dem vollen Bestand. */
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-recos]')).forEach(function (box) {
      var zeigen = parseInt(box.getAttribute('data-pww-recos-zeigen'), 10) || 4;
      var imKasten = {};
      var sichtbar = 0;

      Array.prototype.slice.call(box.querySelectorAll('.pww-prod')).forEach(function (karte) {
        var handle = handleVon(karte);
        var doppelt = handle && (gesehen[handle] || imKasten[handle]);
        var passt = !doppelt && sichtbar < zeigen;
        karte.hidden = !passt;
        if (!passt) return;
        sichtbar += 1;
        if (handle) imKasten[handle] = true;
      });

      /* Erst nach dem ganzen Kasten vormerken, und nur das Gezeigte: die
         versteckte Reserve darf dem naechsten Abschnitt nicht fehlen. */
      Object.keys(imKasten).forEach(function (handle) {
        gesehen[handle] = true;
      });

      /* Bleibt nichts uebrig, faellt der ganze Abschnitt weg – eine
         Ueberschrift ohne Produkte ist schlimmer als gar nichts. */
      var huelle = box.closest('.pww-pdp');
      if (huelle) huelle.hidden = sichtbar === 0;
    });
  }

  function initRecos(box) {
    if (box.dataset.pwwInit === 'true') return;
    box.dataset.pwwInit = 'true';

    if (box.getAttribute('data-pww-recos-done') === 'true') return;
    var url = box.getAttribute('data-pww-recos-url');
    if (!url) return;

    /* Zweite Adresse fuer den Rueckfall: "Passt dazu" ist von Hand gepflegt und
       fehlt bei vielen Produkten. Kommt von dort nichts, werden die
       algorithmischen Empfehlungen nachgeholt. */
    var rueckfall = box.getAttribute('data-pww-recos-fallback');

    function laden(adresse, darfZurueckfallen) {
      return fetch(adresse)
        .then(function (r) {
          if (!r.ok) throw new Error('Empfehlungen: ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var neu = doc.querySelector('[data-pww-recos]');
          var karten = neu ? neu.querySelectorAll('.pww-prod').length : 0;

          if (karten === 0 && darfZurueckfallen && rueckfall) {
            return laden(rueckfall, false);
          }
          if (!neu || karten === 0) return;

          box.innerHTML = neu.innerHTML;
          recosEntdoppeln();
          initAkkordeonAlle();
          initFreistellerAlle();
          /* Die Sprungleiste muss danach neu entscheiden, welche Tabs ein Ziel
             mit Inhalt haben. */
          document.dispatchEvent(new CustomEvent('pww:inhalt'));
        });
    }

    laden(url, true).catch(function () {
      /* Ohne Empfehlungen bleibt der Abschnitt leer – kein Platzhalter. */
    });
  }

  /* ------------------------------------------- Zuletzt besuchte Produkte */

  /* Derselbe Schluessel wie im Live-Theme, damit die Historie zwischen den
     beiden Themes nicht auseinanderlaeuft. Form: [{handle, t}], neueste zuerst. */
  var RECENT_KEY = 'theme:recently-viewed';
  var RECENT_MAX = 12;

  function recentLesen() {
    try {
      var roh = window.localStorage.getItem(RECENT_KEY);
      if (!roh) return [];
      var liste = JSON.parse(roh);
      if (!Array.isArray(liste)) return [];
      return liste.filter(function (e) {
        return e && typeof e.handle === 'string' && e.handle;
      });
    } catch (e) {
      return [];
    }
  }

  function recentMerken(handle) {
    if (!handle) return;
    /* MUSTER-Artikel gar nicht aufnehmen – sie sind Gratismuster und gehoeren
       nicht in eine Merkliste. */
    if (handle.indexOf('-muster') > -1) return;
    try {
      var liste = recentLesen().filter(function (e) {
        return e.handle !== handle;
      });
      liste.unshift({ handle: handle, t: Date.now() });
      window.localStorage.setItem(RECENT_KEY, JSON.stringify(liste.slice(0, RECENT_MAX)));
    } catch (e) {
      /* Privater Modus oder voller Speicher – dann gibt es eben keine Historie. */
    }
  }

  function initRecent(box) {
    if (box.dataset.pwwInit === 'true') return;
    box.dataset.pwwInit = 'true';

    var jetzt = box.getAttribute('data-pww-recent-handle') || '';
    var anzahl = parseInt(box.getAttribute('data-pww-recent-count'), 10);
    if (isNaN(anzahl) || anzahl < 1) anzahl = 4;
    var titel = box.getAttribute('data-pww-recent-heading') || '';
    var hintergrund = box.getAttribute('data-pww-recent-background') === 'white' ? 'white' : 'warm';

    /* Erst lesen, dann merken: sonst stuende das Produkt, auf dem man gerade
       ist, in seiner eigenen Liste. */
    var handles = recentLesen()
      .map(function (e) {
        return e.handle;
      })
      .filter(function (h) {
        return h !== jetzt;
      })
      .slice(0, anzahl);

    recentMerken(jetzt);

    if (!handles.length) return;

    /* Jede Karte kommt aus templates/product.pww-card.liquid – dieselbe Karte
       wie in den Empfehlungen. MUSTER liefert dort eine leere Antwort. */
    Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '?view=pww-card')
          .then(function (r) {
            return r.ok ? r.text() : '';
          })
          .catch(function () {
            return '';
          });
      })
    ).then(function (teile) {
      var karten = teile
        .map(function (t) {
          return (t || '').trim();
        })
        .filter(function (t) {
          return t.indexOf('pww-prod') > -1;
        });

      if (!karten.length) return;

      box.innerHTML =
        '<div class="pww-sec ' +
        (hintergrund === 'white' ? 'pww-sec--white' : 'pww-sec--warm') +
        '"><div class="pww-pdp__inner">' +
        (titel ? '<h2 class="pww-sec__title">' + titel + '</h2>' : '') +
        '<div class="pww-cards">' +
        karten.join('') +
        '</div></div></div>';

      initFreistellerAlle();
      document.dispatchEvent(new CustomEvent('pww:inhalt'));
    });
  }

  /* ------------------------------------------------ Freisteller-Erkennung */

  /* Liquid sieht nicht, ob ein Bild freigestellt ist – dafuer muessen die
     Pixel gelesen werden. Deshalb hier: eine 64px-Kopie in ein Canvas,
     Ecken pruefen und den Inhalt vermessen.

     Fotos mit Hintergrund – Lifestyle-Aufnahmen, Infografiken – behalten den
     normalen Rand, sonst stehen sie in einem weissen Rahmen. Freisteller
     bekommen den Zuschlag aus dem CSS. Bringt ein Bild schon selbst reichlich
     Rand mit, entfaellt der Zuschlag, damit die Packung nicht zweimal
     verkleinert wird. */

  var EIGENRAND = 0.12; /* ab so viel eigenem Rand kein Zuschlag mehr */
  var HELL = 190; /* so hell muss eine Ecke sein, damit sie als Hintergrund gilt */
  var ECKEN_SPANNE = 30; /* so aehnlich muessen die vier Ecken untereinander sein */
  var TOLERANZ = 45; /* Abstand zur Ecken-Farbe, bis zu dem ein Pixel leer ist */
  var freiCache = {};

  /* Die Nummer im Schluessel ist die Fassung der Messung. Wird an den
     Schwellwerten geschraubt, muss sie hoch – sonst liefert der Speicher im
     offenen Tab weiter die Ergebnisse der alten Regel. */
  function freiSchluessel(url) {
    return 'pww-frei2:' + url.replace(/[?&]width=\d+/, '');
  }

  function freiGelesen(url) {
    if (freiCache[url] !== undefined) return freiCache[url];
    try {
      var s = window.sessionStorage.getItem(freiSchluessel(url));
      return s === null ? undefined : parseFloat(s);
    } catch (e) {
      return undefined;
    }
  }

  function freiMerken(url, wert) {
    freiCache[url] = wert;
    try {
      window.sessionStorage.setItem(freiSchluessel(url), String(wert));
    } catch (e) {
      /* Privater Modus – dann wird eben bei jedem Aufruf neu gemessen. */
    }
  }

  /* Gibt den vorhandenen Eigenrand als Anteil zurueck, oder -1 wenn das Bild
     kein Freisteller ist. */
  function randMessen(bild) {
    var w = bild.naturalWidth;
    var h = bild.naturalHeight;
    if (!w || !h) return -1;

    var c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    var ctx = c.getContext('2d');
    if (!ctx) return -1;
    ctx.drawImage(bild, 0, 0);

    var dat;
    try {
      dat = ctx.getImageData(0, 0, w, h).data;
    } catch (e) {
      return -1; /* Canvas verunreinigt – ohne CORS keine Messung */
    }

    function farbe(x, y) {
      var o = (y * w + x) * 4;
      return [dat[o], dat[o + 1], dat[o + 2], dat[o + 3]];
    }

    /* Die vier Ecken sind die Referenz fuer den Hintergrund. Ein fester
       Weiss-Wert reicht nicht: die WebP-Fassungen der Packshots haben einen
       leichten Farbstich, Rot faellt in den Ecken bis auf 209. */
    var ecken = [farbe(0, 0), farbe(w - 1, 0), farbe(0, h - 1), farbe(w - 1, h - 1)];
    var sichtbar = [];
    for (var e = 0; e < 4; e++) {
      if (ecken[e][3] >= 24) sichtbar.push(ecken[e]);
    }

    var grund = null;
    if (sichtbar.length) {
      /* Jede sichtbare Ecke muss hell sein und alle muessen zueinander
         passen – sonst steht dort ein Motiv und es ist kein Freisteller. */
      var summe = [0, 0, 0];
      for (var k = 0; k < 3; k++) {
        var min = 255;
        var max = 0;
        for (var s = 0; s < sichtbar.length; s++) {
          var v = sichtbar[s][k];
          summe[k] += v;
          if (v < min) min = v;
          if (v > max) max = v;
        }
        if (min < HELL || max - min > ECKEN_SPANNE) return -1;
      }
      grund = [summe[0] / sichtbar.length, summe[1] / sichtbar.length, summe[2] / sichtbar.length];
    }

    function leer(x, y) {
      var o = (y * w + x) * 4;
      if (dat[o + 3] < 24) return true;
      if (!grund) return false;
      var abstand =
        Math.abs(dat[o] - grund[0]) +
        Math.abs(dat[o + 1] - grund[1]) +
        Math.abs(dat[o + 2] - grund[2]);
      return abstand <= TOLERANZ;
    }

    var x0 = w;
    var y0 = h;
    var x1 = -1;
    var y1 = -1;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        if (leer(x, y)) continue;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
      }
    }
    if (x1 < 0) return -1; /* voellig leeres Bild */

    /* Der kleinste der vier Raender zaehlt – Rand wird ja symmetrisch
       ergaenzt, und beschnitten werden soll nichts. */
    return Math.min(y0 / h, (h - 1 - y1) / h, x0 / w, (w - 1 - x1) / w);
  }

  function freiSetzen(box, rand) {
    if (rand < 0 || rand >= EIGENRAND) return;
    box.classList.add('is-frei');
  }

  function initFreisteller(bild) {
    if (bild.dataset.pwwFrei === 'true') return;
    bild.dataset.pwwFrei = 'true';

    var box = bild.closest('.pww-prod__media');
    if (!box) return;

    var quelle = bild.currentSrc || bild.getAttribute('src');
    if (!quelle || quelle.indexOf('data:') === 0) return;

    var bekannt = freiGelesen(quelle);
    if (bekannt !== undefined && !isNaN(bekannt)) {
      freiSetzen(box, bekannt);
      return;
    }

    /* 64px reicht: gemessen wird nur, wo Inhalt anfaengt. Eine eigene
       Instanz mit crossOrigin, weil ein bereits geladenes Bild ohne
       CORS-Kopfzeilen das Canvas verunreinigen wuerde. */
    var klein = /[?&]width=\d+/.test(quelle)
      ? quelle.replace(/([?&])width=\d+/, '$1width=64')
      : quelle + (quelle.indexOf('?') > -1 ? '&' : '?') + 'width=64';

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      var rand = randMessen(probe);
      freiMerken(quelle, rand);
      freiSetzen(box, rand);
    };
    probe.onerror = function () {
      freiMerken(quelle, -1);
    };
    probe.src = klein;
  }

  function initFreistellerAlle() {
    Array.prototype.slice
      .call(document.querySelectorAll('.pww-prod__media img'))
      .forEach(initFreisteller);
  }

  /* --------------------------------------------- Sterneverteilung Judge.me */

  /* Judge.me schreibt die Verteilung nur ins Widget-Markup, nicht in
     Metafelder. Steht sie dort, werden daraus die Balken gebaut. */
  function initHist(ziel) {
    if (ziel.dataset.pwwInit === 'true') return;
    ziel.dataset.pwwInit = 'true';

    var bereich = ziel.closest('.pww-rev') || document;
    var widget = bereich.querySelector('[data-pww-rev-widget]');
    if (!widget) return;

    var reihen = Array.prototype.slice.call(widget.querySelectorAll('.jdgm-histogram__row[data-rating]'));
    if (!reihen.length) return;

    var teile = [];
    reihen
      .filter(function (r) {
        return r.getAttribute('data-rating') && r.getAttribute('data-frequency') !== null;
      })
      .forEach(function (r) {
        var stern = r.getAttribute('data-rating');
        var anzahl = r.getAttribute('data-frequency');
        var prozent = parseFloat(r.getAttribute('data-percentage')) || 0;
        teile.push(
          '<span>' + stern + ' ★</span>' +
            '<span class="pww-rev__histbar"><span class="pww-rev__histfill" style="width:' +
            prozent +
            '%"></span></span>' +
            '<span>' + anzahl + '</span>'
        );
      });

    if (!teile.length) return;
    ziel.innerHTML = teile.join('');
    ziel.hidden = false;
  }

  /* -------------------------------------------------- Bewertungskarten */

  function sterneSvg(bewertung) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      var voll = bewertung - i + 1;
      var gefuellt = voll >= 0.75;
      out +=
        '<svg width="15" height="15" viewBox="0 0 20 20" aria-hidden="true">' +
        '<path d="M10 1.6l2.6 5.27 5.82.85-4.21 4.1.99 5.79L10 14.87l-5.2 2.74.99-5.79-4.21-4.1 5.82-.85z" ' +
        (gefuellt
          ? 'fill="currentColor"'
          : 'fill="none" stroke="currentColor" stroke-width="1.1" opacity="0.45"') +
        '/></svg>';
    }
    return out;
  }

  /* Judge.me liefert die Bewertungen als fertiges Markup im Metafeld, laesst
     es hier aber auf display:none stehen. Aus diesen Knoten werden die Karten
     im Design gebaut. Kein Avatar-Foto: Judge.me hat keins, es gibt nur den
     Anfangsbuchstaben – ein erfundenes Portrait waere schlicht falsch. */
  function schuetzen(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  /* Liest die Bewertungen aus dem Judge.me-Markup und gibt sie als einfache
     Objekte zurueck. Wird von der Spur auf der Seite und vom Overlay genutzt,
     damit beide dieselben Karten zeigen. */
  function revLesen(widget) {
    if (!widget) return [];
    return Array.prototype.slice
      .call(widget.querySelectorAll('.jdgm-rev'))
      .map(function (rev) {
        var bewertungEl = rev.querySelector('[data-score]');
        var punkte = bewertungEl ? parseFloat(bewertungEl.getAttribute('data-score')) : 0;
        var text = (rev.querySelector('.jdgm-rev__body') || {}).textContent || '';
        var titel = ((rev.querySelector('.jdgm-rev__title') || {}).textContent || '').trim();
        var name = ((rev.querySelector('.jdgm-rev__author') || {}).textContent || '').trim();
        var stempel = rev.querySelector('.jdgm-rev__timestamp');
        var datum = stempel ? (stempel.getAttribute('data-content') || '').slice(0, 10) : '';
        var geprueft = rev.getAttribute('data-verified-buyer') === 'true';

        text = text.trim();
        if (!text) return null;
        return { punkte: punkte, titel: titel, text: text, name: name || 'Anonym', datum: datum, geprueft: geprueft };
      })
      .filter(Boolean);
  }

  function revKarteHtml(k, mitTitel) {
    var unten = [];
    if (k.geprueft) unten.push('Verifizierter Kauf');
    if (k.datum) unten.push(k.datum);
    return (
      '<article class="pww-revcard">' +
      '<span class="pww-revcard__stars">' + sterneSvg(k.punkte) + '</span>' +
      (mitTitel && k.titel ? '<strong class="pww-revcard__title">' + schuetzen(k.titel) + '</strong>' : '') +
      '<p class="pww-revcard__body">«' + schuetzen(k.text) + '»</p>' +
      '<div class="pww-revcard__foot">' +
      '<span class="pww-revcard__avatar" aria-hidden="true">' + schuetzen(k.name.charAt(0).toUpperCase()) + '</span>' +
      '<span class="pww-revcard__who">' +
      '<span class="pww-revcard__name">' + schuetzen(k.name) + '</span>' +
      (unten.length ? '<span class="pww-revcard__meta">' + schuetzen(unten.join(' · ')) + '</span>' : '') +
      '</span></div></article>'
    );
  }

  function initRevKarten(spur) {
    if (spur.dataset.pwwInit === 'true') return;
    spur.dataset.pwwInit = 'true';

    var bereich = spur.closest('.pww-rev') || document;
    var widget = bereich.querySelector('[data-pww-rev-widget]');
    var nav = bereich.querySelector('[data-pww-rev-nav]');
    if (!widget) return;

    var quellen = Array.prototype.slice.call(widget.querySelectorAll('.jdgm-rev'));
    if (!quellen.length) return;

    var karten = quellen
      .map(function (rev) {
        var bewertungEl = rev.querySelector('[data-score]');
        var punkte = bewertungEl ? parseFloat(bewertungEl.getAttribute('data-score')) : 0;
        var text = (rev.querySelector('.jdgm-rev__body') || {}).textContent || '';
        var name = ((rev.querySelector('.jdgm-rev__author') || {}).textContent || '').trim();
        var stempel = rev.querySelector('.jdgm-rev__timestamp');
        var datum = stempel ? (stempel.getAttribute('data-content') || '').slice(0, 10) : '';
        var geprueft = rev.getAttribute('data-verified-buyer') === 'true';

        text = text.trim();
        if (!text) return null;

        return { punkte: punkte, text: text, name: name || 'Anonym', datum: datum, geprueft: geprueft };
      })
      .filter(Boolean);

    if (!karten.length) return;

    spur.innerHTML = karten
      .map(function (k) {
        return revKarteHtml(k, false);
      })
      .join('');

    if (!nav) return;
    nav.hidden = false;

    var zurueck = nav.querySelector('[data-pww-rev-prev]');
    var weiter = nav.querySelector('[data-pww-rev-next]');

    function schieben(richtung) {
      var erste = spur.querySelector('.pww-revcard');
      var schritt = erste ? erste.offsetWidth + 20 : spur.clientWidth;
      /* Sanft macht scroll-behavior im CSS, hier nur die Zuweisung. */
      spur.scrollLeft = spur.scrollLeft + schritt * richtung;
    }

    function pfeilePruefen() {
      var rest = spur.scrollWidth - spur.clientWidth - spur.scrollLeft;
      if (zurueck) zurueck.disabled = spur.scrollLeft <= 2;
      if (weiter) weiter.disabled = rest <= 2;
    }

    if (zurueck) zurueck.addEventListener('click', function () { schieben(-1); });
    if (weiter) weiter.addEventListener('click', function () { schieben(1); });
    spur.addEventListener('scroll', pfeilePruefen, { passive: true });
    window.addEventListener('resize', pfeilePruefen);
    pfeilePruefen();
  }

  /* ------------------------------------------- Overlay alle Bewertungen */

  /* Das Overlay wird aus denselben Karten gebaut wie der Abschnitt auf der
     Seite – nicht aus dem Judge.me-Markup.

     Frueher wanderte das echte Widget hinein. Das sah fremd aus (gruene
     Bloecke, eigene Sterne) und brachte nichts: Judge.mes Blaetterleiste war
     auch am Originalplatz ohne Wirkung, weil ins Theme nur das Markup aus dem
     Metafeld kommt, nicht deren App-Block. Ohne den bindet Judge.me seine
     Klick-Handler nicht, und der Widget-Endpunkt antwortet ohne ihre interne
     Widget-ID mit 404. Eine tote "1 2 3"-Leiste im Overlay ist schlechter als
     keine – darum steht jetzt die Zahl da, was gezeigt wird. */
  function initRevModal(modal) {
    if (modal.dataset.pwwInit === 'true') return;
    modal.dataset.pwwInit = 'true';

    /* bereich vor dem Umhaengen bestimmen – danach findet closest() den
       Bewertungsabschnitt nicht mehr.

       Gesucht wird ueber data-pww-rev-product, nicht ueber .pww-pdp: der Kasten
       traegt diese Klasse selbst, seit er an <body> wandert (sonst fehlten dort
       Farben und Masse). closest() faengt beim Element selbst an – es fand also
       sich selbst statt des Abschnitts, der Oeffner blieb ungefunden und der
       Klick tat nichts. */
    var bereich = modal.closest('[data-pww-rev-product]') || modal.closest('.pww-pdp') || document;
    var oeffner = bereich.querySelector('[data-pww-rev-all]');
    var koerper = modal.querySelector('[data-pww-modal-body]');
    var schliessen = modal.querySelector('[data-pww-modal-close]');
    if (!oeffner || !koerper) return;

    /* Gleicher Grund wie bei der Bildansicht: in .site-main (z-index 500) liegt
       die Ankuendigungsleiste (1200) darueber, und oben blieb ein Streifen der
       Seite sichtbar. An <body> gehaengt deckt das Overlay wirklich alles ab. */
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    var gebaut = false;

    function gesamtzahl() {
      var huelle = bereich.querySelector('[data-number-of-reviews]');
      return huelle ? parseInt(huelle.getAttribute('data-number-of-reviews'), 10) || 0 : 0;
    }

    function listeHtml(karten, gesamt, laedt) {
      var html = '<div class="pww-modal__list">' +
        karten
          .map(function (k) {
            return revKarteHtml(k, true);
          })
          .join('') +
        '</div>';

      if (laedt) {
        html += '<p class="pww-modal__hinweis">Weitere Bewertungen werden geladen …</p>';
      } else if (gesamt > karten.length) {
        /* Bewertungen ohne Text gibt es auch – nur Sterne. Die zaehlen bei
           Judge.me mit, hier waere eine leere Karte sinnlos. Darum die Zahl
           benennen statt sie zu verschweigen. */
        html +=
          '<p class="pww-modal__hinweis">Angezeigt werden ' +
          karten.length +
          ' Bewertungen mit Text von insgesamt ' +
          gesamt +
          '.</p>';
      }
      return html;
    }

    /* Im Widget-Markup, das Judge.me ins Metafeld schreibt, steht nur die erste
       Seite – fuenf Bewertungen. Alles Weitere holt ihr eigener Widget-Endpunkt,
       derselbe, den ihr Skript fuer die Seitenzahlen benutzt. Er braucht keinen
       Schluessel, liefert {html, total_count, page} und deckelt per_page bei 30.

       Erst wird aus dem vorhandenen Markup gebaut, damit das Overlay sofort
       etwas zeigt; die vollstaendige Liste ersetzt es, sobald sie da ist. */
    var JDGM_URL = 'https://api.judge.me/reviews/reviews_for_widget';
    var JDGM_PRO_SEITE = 30;
    var JDGM_MAX_SEITEN = 12;
    var nachgeladen = false;

    function nachladen() {
      var produkt = bereich.getAttribute('data-pww-rev-product');
      if (nachgeladen || !produkt || !window.fetch) return;
      nachgeladen = true;

      var shop = (window.Shopify && window.Shopify.shop) || window.location.host;
      var karten = [];
      var gelesen = 0;
      var gesamt = gesamtzahl();

      function seite(nummer) {
        var adresse =
          JDGM_URL +
          '?url=' + encodeURIComponent(shop) +
          '&shop_domain=' + encodeURIComponent(shop) +
          '&platform=shopify&per_page=' + JDGM_PRO_SEITE +
          '&page=' + nummer +
          '&product_id=' + encodeURIComponent(produkt);

        return window.fetch(adresse)
          .then(function (a) {
            if (!a.ok) throw new Error('HTTP ' + a.status);
            return a.json();
          })
          .then(function (antwort) {
            gesamt = antwort.total_count || gesamt;
            var kasten = document.createElement('div');
            kasten.innerHTML = antwort.html || '';
            var roh = kasten.querySelectorAll('.jdgm-rev').length;
            gelesen += roh;
            karten = karten.concat(revLesen(kasten));

            /* Weiter nur, solange die Seite ueberhaupt etwas gebracht hat –
               sonst laeuft die Kette bis zum Deckel, wenn die Zahlen wegen
               textloser Bewertungen nicht aufgehen. */
            if (roh > 0 && gelesen < gesamt && nummer < JDGM_MAX_SEITEN) {
              return seite(nummer + 1);
            }
          });
      }

      seite(1)
        .then(function () {
          if (karten.length) koerper.innerHTML = listeHtml(karten, gesamt, false);
        })
        .catch(function () {
          /* Endpunkt nicht erreichbar: es bleibt bei den Bewertungen aus dem
             Markup, dann aber mit der ehrlichen Zeile darunter. */
          nachgeladen = false;
          var vorhanden = revLesen(bereich.querySelector('[data-pww-rev-widget]'));
          if (vorhanden.length) koerper.innerHTML = listeHtml(vorhanden, gesamtzahl(), false);
        });
    }

    function bauen() {
      var widget = bereich.querySelector('[data-pww-rev-widget]');
      var karten = revLesen(widget);
      var gesamt = gesamtzahl();

      /* "wird geladen" nur, wenn auch geladen werden kann – sonst stuende die
         Zeile fuer immer da und verspraeche etwas, das nie kommt. */
      var laedt = gesamt > karten.length && !!bereich.getAttribute('data-pww-rev-product') && !!window.fetch;
      koerper.innerHTML = listeHtml(karten, gesamt, laedt);
      gebaut = true;
    }

    function auf() {
      if (!gebaut) bauen();
      nachladen();
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (schliessen) schliessen.focus();
    }

    function zu() {
      modal.hidden = true;
      document.documentElement.style.removeProperty('overflow');
      oeffner.focus();
    }

    oeffner.addEventListener('click', auf);
    if (schliessen) schliessen.addEventListener('click', zu);

    /* Klick auf die Flaeche neben dem Kasten schliesst ebenfalls. */
    modal.addEventListener('click', function (ev) {
      if (ev.target === modal) zu();
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !modal.hidden) zu();
    });
  }

  /* ------------------------------------------- Gratisversand-Balken nachziehen

     Der Balken kommt serverseitig richtig aus dem Liquid. Legt man aber etwas
     in den Warenkorb, laedt die Seite nicht neu – Empire und die Warenkorb-App
     buchen per AJAX – und der Balken zeigte weiter den alten Stand. Erst beim
     Wechsel auf eine andere Seite stimmte er wieder.

     Empire meldet seine Warenkorb-Aenderungen intern ueber einen eigenen
     Event-Bus, nicht als DOM-Event; von aussen ist da nichts abzuhoeren. Statt
     einen zweiten Kaufknopf zu bauen, horchen wir deshalb auf die Anfragen an
     die Warenkorb-Endpunkte – egal ob sie aus dem Theme oder aus einer App
     kommen – und holen danach den Stand aus /cart.js. Die Aufrufe werden
     durchgereicht, es wird nichts umgeleitet. */

  var CART_PFAD = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/i;

  /* Setzt einen Geldbetrag in das Format des Shops. Das Muster steht im Markup,
     damit hier kein zweites "CHF" gepflegt werden muss. */
  function geldText(rappen, muster) {
    var vorlage = muster || 'CHF {{amount}}';
    var platz = /\{\{\s*(\w+)\s*\}\}/;
    var treffer = vorlage.match(platz);
    var name = treffer ? treffer[1] : 'amount';

    var stellen = name.indexOf('no_decimals') > -1 ? 0 : 2;
    var komma = name.indexOf('comma_separator') > -1 ? ',' : '.';
    var tausender = ',';
    if (name.indexOf('comma_separator') > -1) tausender = '.';
    else if (name.indexOf('apostrophe_separator') > -1) tausender = "'";
    else if (name.indexOf('space_separator') > -1) tausender = ' ';

    var teile = (rappen / 100).toFixed(stellen).split('.');
    teile[0] = teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, tausender);
    return vorlage.replace(platz, teile.join(komma));
  }

  function shipSetzen(box, summe) {
    var schwelle = parseInt(box.getAttribute('data-pww-ship-schwelle'), 10);
    var text = box.querySelector('.pww-ship__text');
    var fuellung = box.querySelector('.pww-ship__fill');
    if (!schwelle || !text || !fuellung) return;

    var rest = schwelle - summe;
    var anteil = Math.min(Math.round((summe * 100) / schwelle), 100);

    if (rest > 0) {
      var vorlage = box.getAttribute('data-pww-ship-pending') || '';
      text.textContent = vorlage.replace('[betrag]', geldText(rest, box.getAttribute('data-pww-ship-format')));
    } else {
      text.textContent = box.getAttribute('data-pww-ship-done') || '';
    }
    box.classList.toggle('is-done', rest <= 0);
    fuellung.style.width = anteil + '%';
  }

  var shipLaeuft = false;

  function shipAktualisieren() {
    var boxen = Array.prototype.slice.call(document.querySelectorAll('[data-pww-ship]'));
    if (!boxen.length || shipLaeuft || !window.fetch) return;
    shipLaeuft = true;

    /* Kein cache: die Antwort darf nicht aus dem Browsercache kommen, sonst
       stuende dort der Stand von vor dem Hinzufuegen. */
    window.fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (a) { return a.json(); })
      .then(function (korb) {
        shipLaeuft = false;
        boxen.forEach(function (box) { shipSetzen(box, korb.items_subtotal_price); });
      })
      .catch(function () { shipLaeuft = false; });
  }

  function warenkorbBeobachten() {
    if (window.pwwCartWatch) return;

    /* Nur einhaengen, wenn es auf der Seite ueberhaupt einen Balken gibt.

       window.fetch und XMLHttpRequest.prototype.open werden hier fuer die
       ganze Seite umgebogen – jede Anfrage von GTM, Klaviyo, UpCart und
       Judge.me laeuft danach durch diese Huelle. Seit der Balken von der
       Produktseite auf den Warenkorb umgezogen ist, gab es dort nichts mehr zu
       aktualisieren: shipAktualisieren stieg sofort wieder aus, die Huelle
       blieb aber auf jeder Produktseite bestehen.

       Der Balken kommt nicht nachtraeglich ins Dokument – er steht im Markup
       der Kaufbox oder gar nicht. Einmal pruefen genuegt darum. */
    if (!document.querySelector('[data-pww-ship]')) return;

    window.pwwCartWatch = true;

    var echtesFetch = window.fetch;
    if (echtesFetch) {
      window.fetch = function (eingabe) {
        var adresse = typeof eingabe === 'string' ? eingabe : (eingabe && eingabe.url) || '';
        var antwort = echtesFetch.apply(this, arguments);
        if (CART_PFAD.test(adresse) && antwort && antwort.then) {
          antwort.then(function () { setTimeout(shipAktualisieren, 60); }, function () {});
        }
        return antwort;
      };
    }

    var oeffnen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (methode, adresse) {
      if (CART_PFAD.test(String(adresse || ''))) {
        this.addEventListener('load', function () { setTimeout(shipAktualisieren, 60); });
      }
      return oeffnen.apply(this, arguments);
    };

    /* Zurueck aus dem Verlauf oder aus einem anderen Tab: dort kann sich der
       Warenkorb geaendert haben, ohne dass hier eine Anfrage lief. */
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) shipAktualisieren();
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) shipAktualisieren();
    });
  }

  /* --------------------------------------------- Bewertung schreiben

     Das Formular kommt von Judge.me. Ihr Skript rendert nur Platzhalter, die
     beim Laden im HTML stehen, und es braucht einen Moment dafuer – deshalb
     wird gewartet, bis der Knopf in ihrem Markup auftaucht, und erst dann der
     eigene Knopf gezeigt. Kommt nichts, bleibt er weg, statt ins Leere zu
     fuehren (etwa wenn die App abgeschaltet ist).

     Geoeffnet wird ueber ihre eigene Funktion openForm; die kennt den Weg
     durch ihr Markup. Klappt das nicht, wird ersatzweise ihr eigener Link
     geklickt. */
  var FORM_WARTEN = 8000;
  var FORM_TAKT = 400;

  /* Judge.mes Fenster nennt oben nur den Produktnamen. Ein Bild dazu macht
     klarer, worueber man gerade urteilt – gerade wenn man ueber eine E-Mail
     hereinkommt und mehrere Produkte bestellt hat. Ihr Markup sieht dafuer
     nichts vor, also wird es davorgesetzt.

     Die Seiten des Fensters entstehen nacheinander; deshalb kurz nachfassen
     statt einmal zu schauen. Doppelt eingesetzt wird nichts – die Klasse
     pww-rev__modalbild ist die Bremse. */
  function bildInsFenster(bereich) {
    var quelle = bereich.getAttribute('data-pww-rev-bild');
    if (!quelle) return;

    var versuche = 0;
    var takt = setInterval(function () {
      versuche++;

      /* Der Produktname steht in ihrem Fenster mehrfach – einmal je Schritt.
         Jeder bekommt sein Bild, damit es beim Blaettern nicht verschwindet.
         Geprueft wird auf das eigene Bild davor, nicht auf "kein Vorgaenger":
         vor dem Namen kann auch ihr Gutschein-Banner stehen. */
      Array.prototype.slice
        .call(document.querySelectorAll('.jdgm-write-review-modal__product-title'))
        .forEach(function (titel) {
          var davor = titel.previousElementSibling;
          if (davor && davor.classList.contains('pww-rev__modalbild')) return;
          var bild = document.createElement('img');
          bild.className = 'pww-rev__modalbild';
          bild.src = quelle;
          bild.alt = '';
          titel.parentElement.insertBefore(bild, titel);
        });

      if (versuche >= 8) clearInterval(takt);
    }, 250);
  }

  function initRevForm(bereich) {
    if (bereich.dataset.pwwFormInit === 'true') return;
    bereich.dataset.pwwFormInit = 'true';

    var kasten = bereich.querySelector('[data-pww-rev-form]');
    var knopf = bereich.querySelector('[data-pww-rev-write]');
    if (!kasten || !knopf) return;

    var gewartet = 0;
    var uhr = setInterval(function () {
      gewartet += FORM_TAKT;
      var fertig = kasten.querySelector('.jdgm-write-rev-link');
      if (fertig) {
        clearInterval(uhr);
        knopf.hidden = false;
      } else if (gewartet >= FORM_WARTEN) {
        clearInterval(uhr);
      }
    }, FORM_TAKT);

    /* Notnagel: das Formular an Ort und Stelle ausklappen. Gebraucht nur, wenn
       Judge.mes eigenes Fenster nicht aufgeht. Ihr slideDown laesst
       display: none im Inline-Stil stehen, wenn die Animation nicht
       durchlaeuft – deshalb zwei Sekunden lang nachfassen. */
    function inlineAusklappen() {
      kasten.hidden = false;
      var versuche = 0;
      var takt = setInterval(function () {
        versuche++;
        Array.prototype.slice
          .call(kasten.querySelectorAll('.jdgm-form-wrapper, .jdgm-form-dynamic-wrapper'))
          .forEach(function (teil) {
            teil.style.setProperty('display', 'block', 'important');
          });
        if (versuche >= 10) {
          clearInterval(takt);
          var erstesFeld = kasten.querySelector('.jdgm-form-wrapper input[type="text"]:not([type="hidden"])');
          if (erstesFeld) erstesFeld.focus();
        }
      }, 200);
      kasten.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    knopf.addEventListener('click', function () {
      /* Judge.me kennt zwei Wege. Der eine ist ihr eigenes Fenster
         (.jdgm-write-review-modal, mehrseitig, mit Bildvorschau beim Hochladen),
         der andere das Formular direkt in der Seite. Welcher greift, haengt an
         ihren App-Einstellungen. Beides gleichzeitig zu zeigen war der Fehler
         zuvor: das Fenster ging auf und dahinter klappte noch ein zweites
         Formular aus.

         Darum: ihren Link ausloesen und kurz nachsehen. Ist ihr Fenster offen,
         bleibt hier alles zu. */
      var link = kasten.querySelector('.jdgm-write-rev-link');
      if (link) link.click();

      bildInsFenster(bereich);

      setTimeout(function () {
        var fenster = document.querySelector('.jdgm-write-review-modal');
        var offen = fenster && getComputedStyle(fenster).display !== 'none';
        if (!offen) inlineAusklappen();
      }, 700);
    });
  }

  /* ------------------------------------------------- Grosse Bildansicht

     Klick auf das Hauptbild zeigt alle Bilder gross. Die Ansicht steht fertig
     im Markup (siehe sections/pww-product.liquid) – hier wird nur umgeschaltet,
     damit die Bilder in voller Aufloesung erst beim Oeffnen geladen werden.

     Die Galerie darunter behaelt ihre eigene Auswahl: beim Oeffnen wird ihr
     aktuelles Bild uebernommen, beim Schliessen das in der Ansicht gewaehlte
     zurueckgegeben. Sonst zeigte die Seite hinterher ein anderes Bild als das,
     das man zuletzt angeschaut hat. */
  function initLightbox(kasten) {
    if (kasten.dataset.pwwInit === 'true') return;
    kasten.dataset.pwwInit = 'true';

    var wurzel = kasten.closest('[data-pww-pdp]') || document;

    /* Umhaengen an <body>, bevor irgendetwas gemessen wird: die Ansicht steckt
       im Markup in .site-main, und die hat z-index 500. Die Ankuendigungsleiste
       des Themes liegt mit z-index 1200 darueber – aus dem Stapelkontext von
       .site-main heraus ist sie nicht zu ueberdecken, egal welchen Wert die
       Ansicht bekommt. Oben blieb deshalb ein grüner Streifen stehen, und
       Klicks in den obersten 32px gingen an die Leiste statt an die Ansicht.

       wurzel zeigt weiter auf die Produktseite, die Verbindung zur Galerie
       bleibt also bestehen. */
    if (kasten.parentElement !== document.body) document.body.appendChild(kasten);
    var oeffner = wurzel.querySelector('[data-pww-gal-open]');
    var folien = Array.prototype.slice.call(kasten.querySelectorAll('[data-pww-lb-slide]'));
    var daumen = Array.prototype.slice.call(kasten.querySelectorAll('[data-pww-lb-thumb]'));
    var schliesser = kasten.querySelector('[data-pww-lightbox-close]');
    if (!oeffner || !folien.length) return;

    var buehne = kasten.querySelector('.pww-lightbox__stage');
    var jetzt = 0;

    /* --------------------------------------------------------------- Lupe

       Ein Klick auf das Bild vergroessert um den angeklickten Punkt herum, die
       Maus verschiebt danach den Ausschnitt, ein zweiter Klick geht zurueck.
       Der Punkt wird als transform-origin gesetzt; ohne ihn zeigte die Lupe
       immer die Bildmitte, egal wo man hinklickt. */
    function ursprungSetzen(bild, ev) {
      var kante = bild.getBoundingClientRect();
      var x = ((ev.clientX - kante.left) / kante.width) * 100;
      var y = ((ev.clientY - kante.top) / kante.height) * 100;
      bild.style.transformOrigin =
        Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
    }

    function lupeAus() {
      if (!buehne) return;
      buehne.classList.remove('is-zoom');
      folien.forEach(function (f) {
        var bild = f.querySelector('img');
        if (bild) bild.style.removeProperty('transform-origin');
      });
    }

    function zeigen(index) {
      if (index < 0) index = folien.length - 1;
      if (index >= folien.length) index = 0;
      jetzt = index;
      /* Beim Bildwechsel zurueck auf Normalgroesse – ein vergroesserter
         Ausschnitt des vorigen Bildes passt nicht zum naechsten. */
      lupeAus();
      folien.forEach(function (f, i) {
        f.classList.toggle('is-active', i === index);
      });
      daumen.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function auf() {
      /* Erst jetzt die grossen Fassungen holen – im Markup stehen nur die
         Adressen. Alle auf einmal, damit das Blaettern nicht stockt. */
      bilderScharf(kasten);

      /* Von der Galerie uebernehmen, welches Bild gerade vorne steht. */
      var aktiv = wurzel.querySelector('.pww-gal__slide.is-active');
      var start = aktiv ? parseInt(aktiv.getAttribute('data-pww-slide'), 10) : 0;
      zeigen(isNaN(start) ? 0 : start);

      kasten.hidden = false;
      document.documentElement.style.overflow = 'hidden';

      /* Fokus auf den Dialog, nicht aufs Schliesskreuz: der programmatische
         Fokus auf dem Knopf liess dessen Fokusring aufleuchten, auch wenn
         per Maus oder Finger geoeffnet wurde. Ein Tab fuehrt weiter zum
         Kreuz, Escape schliesst wie gehabt. */
      kasten.focus({ preventScroll: true });
    }

    function zu() {
      lupeAus();
      kasten.hidden = true;
      document.documentElement.style.removeProperty('overflow');

      /* Auswahl an die Galerie zurueckgeben – ueber deren eigenen Daumenknopf,
         damit dieselbe Logik laeuft wie bei einem Klick im Streifen. */
      var knopf = wurzel.querySelector('[data-pww-thumb="' + jetzt + '"]');
      if (knopf) knopf.click();
      oeffner.focus();
    }

    oeffner.addEventListener('click', function (ev) {
      /* Die Badges liegen ueber dem Bild – ein Klick darauf ist kein Zoom. */
      if (ev.target.closest && ev.target.closest('.pww-gal__badges')) return;
      auf();
    });

    daumen.forEach(function (d, i) {
      d.addEventListener('click', function () { zeigen(i); });
    });

    if (schliesser) schliesser.addEventListener('click', zu);

    kasten.addEventListener('click', function (ev) {
      if (ev.target === kasten) zu();
    });

    if (buehne) {
      buehne.addEventListener('click', function (ev) {
        var bild = ev.target.closest ? ev.target.closest('img') : null;
        if (!bild) return;
        if (buehne.classList.contains('is-zoom')) {
          lupeAus();
          return;
        }
        ursprungSetzen(bild, ev);
        buehne.classList.add('is-zoom');
      });

      buehne.addEventListener('mousemove', function (ev) {
        if (!buehne.classList.contains('is-zoom')) return;
        var bild = buehne.querySelector('.pww-lightbox__slide.is-active img');
        if (bild) ursprungSetzen(bild, ev);
      });
    }

    document.addEventListener('keydown', function (ev) {
      if (kasten.hidden) return;
      if (ev.key === 'Escape') zu();
      if (ev.key === 'ArrowRight') zeigen(jetzt + 1);
      if (ev.key === 'ArrowLeft') zeigen(jetzt - 1);
    });
  }

  /* ------------------------------------------------------------------- Start */

  function initAkkordeonAlle() {
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-acc]')).forEach(initAkkordeon);
  }

  function initAll() {
    stickyVersatz();
    galerieDeckel();
    warenkorbBeobachten();
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-pdp]')).forEach(initProdukt);
    initAkkordeonAlle();
    initAnkerAufklappen();
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-tabs]')).forEach(initTabs);
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-recos]')).forEach(initRecos);
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-recent]')).forEach(initRecent);
    initFreistellerAlle();
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-hist]')).forEach(initHist);
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-rev-track]')).forEach(initRevKarten);
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-modal]')).forEach(initRevModal);
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-rev-product]')).forEach(initRevForm);
    Array.prototype.slice.call(document.querySelectorAll('[data-pww-lightbox]')).forEach(initLightbox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('resize', stickyVersatz);
  window.addEventListener('resize', galerieDeckel);
  window.addEventListener('load', galerieDeckel);

  /* Die restlichen Galeriebilder kurz nach dem Aufbau nachladen – dann sind
     sie da, bevor jemand weiterklickt, kosten aber nichts beim Aufschlagen.

     Bewusst nicht an window.load gehaengt: das feuert erst, wenn auch GTM,
     Klaviyo, UpCart und die uebrigen Apps fertig sind – auf dem Handy gern
     erst nach vielen Sekunden, und so lange blieben alle weiteren Folien
     leer. DOMContentLoaded plus Pause laesst dem ersten Bild und der CSS
     den Vortritt, mehr braucht es nicht. */
  function restNachladen() {
    setTimeout(function () {
      Array.prototype.slice.call(document.querySelectorAll('.pww-gal__stage')).forEach(bilderScharf);
    }, 1200);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restNachladen);
  } else {
    restNachladen();
  }

  /* Theme-Editor rendert Sections neu */
  document.addEventListener('shopify:section:load', initAll);
})();
